<!-- 顶部菜单 -->
<template>
  <div class="topmenu">
    <div class="top_1">
      <router-link tag="a" to="/"
        ><img src="../../assets/img/logo.png" class="logo"
      /></router-link>
    </div>
    <div class="top_menu" :class="{ searchShow: isIndex }">
      <ul class="menu_1">
        <li>
          <router-link tag="a" class="menu_1a" to="/" exact>首页</router-link>
        </li>
        <li v-for="(item, index) in menudata" :key="index">
          <!-- <router-link tag="div" class="menu_1a" :to="item.Link+'?FileClassify=1&RootId='+item.Id+'&InteralDirId=19'">{{item.Name}}</router-link> -->
          <router-link
            :to="
              item.Children[0].Link +
                '?FileClassify=' +
                item.Children[0].FileClassifyNum +
                '&RootId=' +
                item.Children[0].Id +
                '&InteralDirId=' +
                item.Children[0].Id
            "
            class="menu_1a"
            >{{ item.Name }}</router-link
          >
          <div class="menu_2" :class="'menu_2' + item.Id" v-if="item.Children">
            <router-link
              v-for="(item2, index2) in item.Children"
              :key="index2"
              tag="a"
              :to="
                item2.Name != '宣传物料'
                  ? item2.Link +
                    '?FileClassify=' +
                    item2.FileClassifyNum +
                    '&RootId=' +
                    item.Id +
                    '&InteralDirId=' +
                    item2.Id
                  :item2.url
              "
              >{{ item2.Name }}</router-link
            >
          </div>
        </li>

        <li>
          <router-link tag="a" class="menu_1a" to="/news" exact
            >新闻公告</router-link
          >
        </li>
      </ul>

      <div class="menu_search" v-if="!isIndex">
        <input type="text" @keydown.enter="ToSearch" v-model="TitleName" />
        <img src="../../assets/img/menu_search.png" @click="ToSearch()" />
      </div>
      <div class="menu_login" v-for="(item, index) in logindate" :key="index">
        <router-link class="no_login" v-if="!loginState" tag="div" to="/login"
          >登录</router-link
        >
        <div class="in_login" v-if="loginState">
          <router-link
            tag="a"
            to="/homepage"
            class="headPortrait"
            @mouseover.native="getMessageCount()"
            v-if="loginState"
            v-bind:style="{
              backgroundImage: 'url(' + item.headPortrait_url + ')'
            }"
          ></router-link>
          <div class="login_menu">
            <router-link tag="a" to="/homepage">个人主页</router-link>
            <router-link tag="a" to="/homepage/collect">我的收藏</router-link>
            <router-link tag="a" to="/message">
              消息
              <span style="color:#ff9966;">{{
                messageCount | fileterMessage
              }}</span>
            </router-link>
            <router-link tag="a" to="/setting">账号设置</router-link>
            <a @click="logout">退出</a>
          </div>
        </div>
      </div>
      <router-link tag="a" class="menu_help" to="/help" target="_blank"
        >使用帮助</router-link
      >
    </div>
  </div>
</template>
<script>
import { getMenuData } from "../../assets/js/modules/topMenu";
import { resetRouter } from "@/router";
import { getUnreadCount } from "@/assets/js/modules/userApi";
import { getToken } from "@/assets/js/modules/auth";
import Vue from "vue";
export default {
  inject: ["reload"],
  data() {
    return {
      isIndex: true,
      loginState: false,
      logindate: [
        {
          headPortrait_url: ""
        }
      ],
      menudata: [],
      messageCount: 0, //未读消息数目
      timer: null,
      TitleName: "" //搜索
    };
  },
  methods: {
    logout() {
      this.$store
        .dispatch("user/logout")
        .then(() => {
          console.log("退出成功");
          localStorage.removeItem("userInfo");
          this.$router.push({ path: "/" });
          this.loginState = false;
          this.reload();
          resetRouter();
        })
        .catch(error => {});
    },
    //获取未读消息数目
    getMessageCount(num) {
      if (num) {
        this.messageCount = num;
        return;
      }
      var that = this;
      let Id = JSON.parse(localStorage.getItem("userInfo")).Id;
      clearTimeout(that.timer);
      this.timer = null;
      this.timer = setTimeout(() => {
        getUnreadCount({ Id: Id }).then(res => {
          if (res.data.Success) {
            this.messageCount = res.data.Data;
          }
        });
      }, 500);
    },
    setRead() {
      this.messageCount = 0;
    },
    // 跳转到搜索页面
    ToSearch() {
      if (this.TitleName) {
        this.$router.push({
          path: "/searchResList",
          query: {
            InteralDirId: this.$route.query.InteralDirId,
            TitleName: this.TitleName
          }
        });
      }
    },
    //判断是否登录
    justifyIsLogin() {
      let token = getToken();
      if (token && token != "" && token != null) {
        this.loginState = true;
        var url = JSON.parse(localStorage.getItem("userInfo")).Avatar;
        this.logindate[0].headPortrait_url = url;
      } else {
        this.loginState = false;
      }
    }
  },
  mounted() {
    this.isIndex = this.$route.path == "/";
    if (
      this.$route.path == "/share/photo" ||
      this.$route.path == "/share/artical" ||
      this.$route.path == "/share/ppt" ||
      this.$route.path == "/news/newslist" ||
      this.$route.path == "/news/newsdetails/" ||
      this.$route.path == "/message/message" ||
      this.$route.path == "/homepage/original" ||
      this.$route.path == "/homepage/collect" ||
      this.$route.path == "/setting" ||
      this.$route.path == "/searchResList"
    )
      this.isIndex = true;

    //绑定菜单数据
    var data = this.menudata;

    var FileClassifyNum = 1;
    getMenuData().then(res => {
      this.menudata = res.data.Data;
      for (var i = 0; i < this.menudata.length; i++) {
        if (this.menudata[i].Name == "公司资料") {
          this.menudata[i].Children.splice(1, 0, {
            Name: "宣传物料",
            url:
              "/companyInfo/parkSource?FileClassify=1&RootId=4&InteralDirId=13"
          });
        }
        for (var j = 0; j < this.menudata[i].Children.length; j++) {
          if (
            this.menudata[i].Children[j].Name == "原创作品" ||
            this.menudata[i].Children[j].Name == "经验分享"
          ) {
            FileClassifyNum = 2;
          } else {
            FileClassifyNum = 1;
          }
          Vue.set(
            this.menudata[i].Children[j],
            "FileClassifyNum",
            FileClassifyNum
          );
        }
      }
    });
    this.justifyIsLogin();
  },
  filters: {
    fileterMessage(value) {
      if (value == 0 || !value) {
        return "0";
      }
      if (value > 99) {
        return "99+";
      }
      return value;
    }
  },
  watch: {
    $route(to, from) {
      this.justifyIsLogin();
      this.isIndex = this.$route.path == "/";
      if (
        this.$route.path == "/share/photo" ||
        this.$route.path == "/share/artical" ||
        this.$route.path == "/share/ppt" ||
        this.$route.path == "/news/newslist" ||
        this.$route.path == "/news/newsdetails/" ||
        this.$route.path == "/message/message" ||
        this.$route.path == "/homepage/original" ||
        this.$route.path == "/homepage/collect" ||
        this.$route.path == "/setting" ||
        this.$route.path == "/searchResList"
      )
        this.isIndex = true;
    }
  }
};
</script>
<style scoped>
.topmenu {
  position: relative;
  width: 100%;
  background-color: #fff;
  height: 70px;
  line-height: 90px;
  z-index: 9999;
}
.top_1 {
  width: 300px;
  height: 100%;
  position: absolute;
  z-index: 200;
  top: 0;
  left: 50%;
  background-color: #fff;
  margin-left: -640px;
}
.logo {
  display: inline-block;
}
.top_menu {
  position: absolute;
  right: 0;
  top: 0;
  height: 70px;
  z-index: 100;
  min-width: 1005px;
}
.menu_1 {
  height: 70px;
  float: left;
  line-height: 70px;
}
.menu_1 a {
  display: block;
  width: 100%;
  height: 100%;
  color: inherit;
}
.menu_1 > li {
  position: relative;
  float: left;
  width: 120px;
  height: 100%;
  text-align: center;
  cursor: pointer;
}

.menu_1a {
  position: relative;
  width: 130px;
  height: 70px;
  color: #333;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  overflow: hidden;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  transition: 0.5s;
  -webkit-transition: 0.5s;
}
.menu_1a:hover {
  color: #6b95ff;
}
.menu_1a_cur {
  color: #6b95ff;
}
.menu_1a:before {
  content: "";
  position: absolute;
  z-index: -1;
  left: 51%;
  right: 51%;
  bottom: 0;
  background: #6b95ff;
  height: 6px;
  -webkit-transition-property: left, right;
  transition-property: left, right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  border-radius: 3px;
}
.menu_1a:hover:before,
.menu_1a:focus:before,
.menu_1a:active:before {
  left: 15%;
  right: 15%;
}
.menu_2 {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  left: 0;
  border-radius: 0 0 5px 5px;
  overflow: hidden;
  max-height: 0;
  transition: 1s;
  -webkit-transition: 1s;
  top: 120%;
  opacity: 0;
}
.menu_2 a {
  font-size: 15px;
  display: block;
  width: 130px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  cursor: pointer;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
}
.menu_1 > li:hover .menu_2 {
  max-height: 350px;
  top: 100%;
  opacity: 1;
}
.menu_1 > li > .router-link-active {
  color: #6aa9ff;
}
.searchShow .menu_1 > li {
  width: 120px;
}
.searchShow .menu_2 {
  left: -10px;
}
.menu_search {
  position: relative;
  float: left;
  width: 89px;
  border: 1px solid #6aa9ff;
  height: 40px;
  border-radius: 25px;
  margin: 13px 0 0 10px;
  overflow: hidden;
  line-height: 40px;
  transition: 1s;
  -webkit-transition: 1s;
  /* animation: menu_search 1s ease-in-out forwards; */
}
.menu_search:hover {
  width: 350px;
}
@keyframes menu_search {
  0% {
    width: 0;
  }
}
.menu_search input[type="text"] {
  position: absolute;
  height: 100%;
  width: 66%;
  top: 0;
  left: 15px;
  border: 0;
  color: #666;
}
.menu_search img {
  cursor: pointer;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
.menu_help {
  display: block;
  color: #666;
  float: right;
  height: 70px;
  line-height: 70px;
  margin: 0 20px 0 50px;
  transition: 0.5s;
  -webkit-transition: 0.5s;
}
.menu_help:hover {
  color: #6aa9ff;
}
.menu_login {
  float: right;
  height: 100%;
  min-width: 36px;
  margin-right: 24px;
}
.no_login {
  border: 1px solid #6aa9ff;
  width: 80px;
  height: 30px;
  text-align: center;
  color: #666;
  line-height: 30px;
  margin: 20px 0 0 0;
  cursor: pointer;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  background: #6aa9ff;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
.no_login:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.no_login:hover,
.no_login:focus,
.no_login:active {
  color: white;
}
.no_login:hover:before,
.no_login:focus:before,
.no_login:active:before {
  -webkit-transform: scale(0);
  transform: scale(0);
}
.in_login {
  width: 36px;
  height: 100%;
  position: relative;
  cursor: pointer;
}
.headPortrait {
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  background-size: cover;
  background-position: center;
  margin: 16px 0 0 0;
  line-height: 36px;
  background-color: #e7e7e7;
  background-image: url(../../assets/img/headPortrait.png);
  background-repeat: no-repeat;
}
.login_menu {
  position: absolute;
  top: 120%;
  right: -5px;
  background-color: rgba(255, 255, 255, 0.9);
  width: 125px;
  border-radius: 0 0 5px 5px;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: 1s;
  -webkit-transition: 1s;
}
.login_menu a {
  display: block;
  height: 35px;
  width: 125px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  color: #666;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
}
.menu_2 a:before,
.login_menu a:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #6b95ff;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.menu_2 a:hover,
.menu_2 a:focus,
.menu_2 a:active,
.login_menu a:hover,
.login_menu a:focus,
.login_menu a:active {
  color: white;
}
.menu_2 a:hover:before,
.menu_2 a:focus:before,
.menu_2 a:active:before,
.login_menu a:hover:before,
.login_menu a:focus:before,
.login_menu a:active:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
  -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
}
.in_login:hover .login_menu {
  max-height: 350px;
  top: 100%;
  opacity: 1;
}
@media screen and (max-width: 1300px) {
  .menu_help {
    margin: 0 20px 0 40px;
  }
}
@import "./assets/css/main.css";
</style>



// WEBPACK FOOTER //
// src/components/common/topmenu.vue